import React from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { FeaturesSection } from './FeaturesSection';
import { ValueStack } from './ValueStack';
import { CTAButton } from './CTAButton';
import { GuaranteeBar } from './GuaranteeBar';
import { Footer } from './Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-zenith-bg text-zenith-text font-sans selection:bg-zenith-red/30 selection:text-white" data-id="element-58">
      <UrgencyBar data-id="element-59" />

      <main data-id="element-60">
        <HeroSection data-id="element-61" />
        <FeaturesSection data-id="element-62" />
        <ValueStack data-id="element-63" />

        <section className="pb-24 px-4 text-center relative" data-id="element-64">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-zenith-red/5 rounded-full blur-[100px] pointer-events-none" data-id="element-65" />
          <div className="relative z-10" data-id="element-66">
            <CTAButton data-id="element-67" />
          </div>
        </section>

        <GuaranteeBar data-id="element-68" />
      </main>

      <Footer data-id="element-69" />
    </div>;
}